// ============================================================================
// AutoMate — shared debug-log helper
//
// Thin wrapper around `console.log` gated on the `AI_AGENT_DEBUG_LOGS` feature
// flag defined in `src/Ateam-BI/AutoMate/constants.js`. When the flag is off
// the call is a no-op; when it's on, logs are prefixed so multiple concurrent
// sites (chat, search popup, autocomplete suggestions, WebSocket client) are
// easy to correlate in the console.
//
// Intentionally NOT used for errors. Unexpected transport failures, subscription
// drops, and GraphQL error payloads should continue to go through
// `console.error` / `console.warn` unconditionally — those are operational
// signals we always want surfaced, not debug traces.
//
// Usage:
//   import { createDebugLog } from 'src/Ateam-BI/AutoMate/utils/aiDebugLog';
//   const debugLog = createDebugLog('[useAgentChat]');
//   debugLog('submit', { messageLength: message.length });
// ============================================================================

import { AI_AGENT_DEBUG_LOGS } from 'src/Ateam-BI/AutoMate/constants';

/**
 * Build a debug logger bound to a stable prefix.
 *
 * @param {string} prefix – short, bracketed tag for easy filtering (e.g.
 *    `'[useAgentChat]'`). Rendered as the first console argument on every
 *    call so grepping the devtools console by prefix pulls all of that
 *    site's debug output.
 * @returns {(...args: any[]) => void} logger that is a no-op when the
 *    `AI_AGENT_DEBUG_LOGS` flag is off.
 */
export const createDebugLog = (prefix) => (...args) => {
  if (AI_AGENT_DEBUG_LOGS) {
    // eslint-disable-next-line no-console
    console.log(prefix, ...args);
  }
};
